import { Link } from 'react-router-dom';

export function SettingsFooter() {
  return (
    <div className="mt-2 flex items-center justify-center gap-3 text-xs text-telekinesis-neutral-300">
      <Link
        to="/terms-of-service"
        className="transition-colors hover:text-telekinesis-neutral-50"
      >
        Terms of Service
      </Link>
      <span aria-hidden className="text-telekinesis-neutral-700">
        •
      </span>
      <Link
        to="/privacy-policy"
        className="transition-colors hover:text-telekinesis-neutral-50"
      >
        Privacy Policy
      </Link>
    </div>
  );
}
